import { createFileRoute } from "@tanstack/react-router";
import { SignUp } from "@/app/components/SignUp";

export const Route = createFileRoute("/auth/signup")({
  component: SignUp,
});
